import { Button } from '@shared/ui/Button';
import { Select, Input, Label, Field } from '@shared/ui/Input';
import {
  LOGIST_DELIVERY_OPERATION_LABELS,
  type LogistDeliveryAcceptance,
} from '@entities/logistics';
import {
  SubCard,
  SubSectionTitle,
  InlineBtn,
  SubCardSubtitle,
  FormGridRow,
  WideField,
  Msg,
} from './styles';
import { toLocalInput, fromLocalInput } from './helpers';

interface LogistDeliveryAcceptanceCardProps {
  delivery: LogistDeliveryAcceptance;
  setDelivery: React.Dispatch<React.SetStateAction<LogistDeliveryAcceptance>>;
  accepting: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export function LogistDeliveryAcceptanceCard({
  delivery,
  setDelivery,
  accepting,
  onClose,
  onSubmit,
}: LogistDeliveryAcceptanceCardProps) {
  return (
    <SubCard>
      <SubSectionTitle>
        Приёмка груза{' '}
        <InlineBtn onClick={onClose}>
          Закрыть
        </InlineBtn>
      </SubSectionTitle>
      <SubCardSubtitle>
        Это часть накладной со стороны получателя: чем закончилась доставка. Данные уйдут
        оператору черновиком — подписать его должен человек в кабинете оператора, как и
        саму накладную.
      </SubCardSubtitle>
      <FormGridRow>
        <Field>
          <Label>Как приняли</Label>
          <Select
            value={delivery.operation}
            onChange={(e) =>
              setDelivery({
                ...delivery,
                operation: e.target.value as LogistDeliveryAcceptance['operation'],
              })
            }
          >
            {Object.entries(LOGIST_DELIVERY_OPERATION_LABELS).map(([v, label]) => (
              <option key={v} value={v}>
                {label}
              </option>
            ))}
          </Select>
        </Field>
        {delivery.operation !== 'rejection' && (
          <>
            <Field>
              <Label>Масса брутто, кг</Label>
              <Input
                type="number"
                value={delivery.gross_mass_kg ?? ''}
                onChange={(e) =>
                  setDelivery({
                    ...delivery,
                    gross_mass_kg: e.target.value === '' ? null : Number(e.target.value),
                  })
                }
              />
            </Field>
            <Field>
              <Label>Мест</Label>
              <Input
                type="number"
                value={delivery.places ?? ''}
                onChange={(e) =>
                  setDelivery({
                    ...delivery,
                    places: e.target.value === '' ? null : Number(e.target.value),
                  })
                }
              />
            </Field>
            <Field>
              <Label>Состояние груза</Label>
              <Input
                value={delivery.cargo_condition ?? ''}
                placeholder="без замечаний"
                onChange={(e) =>
                  setDelivery({ ...delivery, cargo_condition: e.target.value })
                }
              />
            </Field>
            {/* Три отметки времени формат требует обязательно: по ним
                видно, вовремя ли подали машину и сколько она простояла
                под выгрузкой. */}
            <Field>
              <Label>Подача под выгрузку (по заявке)</Label>
              <Input
                type="datetime-local"
                value={toLocalInput(delivery.stated_arrival_at)}
                onChange={(e) =>
                  setDelivery({
                    ...delivery,
                    stated_arrival_at: fromLocalInput(e.target.value),
                  })
                }
              />
            </Field>
            <Field>
              <Label>Фактически прибыл</Label>
              <Input
                type="datetime-local"
                value={toLocalInput(delivery.arrival_at)}
                onChange={(e) =>
                  setDelivery({ ...delivery, arrival_at: fromLocalInput(e.target.value) })
                }
              />
            </Field>
            <Field>
              <Label>Фактически убыл</Label>
              <Input
                type="datetime-local"
                value={toLocalInput(delivery.departure_at)}
                onChange={(e) =>
                  setDelivery({ ...delivery, departure_at: fromLocalInput(e.target.value) })
                }
              />
            </Field>
          </>
        )}
        {delivery.operation === 'rejection' && (
          <WideField $minWidth={320}>
            <Label>Причина отказа</Label>
            <Input
              value={delivery.rejection_reason ?? ''}
              placeholder="груз повреждён при перевозке"
              onChange={(e) =>
                setDelivery({ ...delivery, rejection_reason: e.target.value })
              }
            />
          </WideField>
        )}
        <Button onClick={onSubmit} disabled={accepting}>
          {accepting ? 'Отправляем…' : 'Оформить приёмку'}
        </Button>
      </FormGridRow>
      {delivery.operation === 'partial' && (
        <Msg>Для частичной приёмки укажите массу или количество мест — что именно приняли.</Msg>
      )}
    </SubCard>
  );
}
